import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useApplication } from '../../AppContext';

const FindMatch = ({ room, setRoom }) => {
	const { t } = useTranslation();
	const [error, setError] = React.useState(false);

	const app = useApplication();

	React.useEffect(() => {

		(async () => {
			try {
				const room = await app.multiplayer.joinPublicGame({
					playerName: app?.userdata?.name,
					name: app?.userdata?.name,
					avatar: app?.userdata?.avatar,
				});

				if (room) {
					setRoom(room);
				}

				setError(false);
			} catch (err) {
				console.log('Error connecting to room', err);
				setError(true);
			}
		})();
	}, [app, setRoom]);

	const content = React.useMemo(() => {
		if (error) {
			return (
				<>{t('There was an error connecting to the server.')}{' '}{t('Please try again later.')}</>
			);
		}

		if (!room) {
			return (
				<>{t('Looking')}...</>
			);
		}

		return null;
	}, [error, room, t]);

	return (
		content
	);
};

export default FindMatch;
